import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const queue = [];
let flushing = false;
const flush = async () => {
  if (flushing || !queue.length) return;
  flushing = true;
  const batch = queue.splice(0, 100);
  try { await api.post("/track/events", { events: batch }); } catch { /* drop silently */ }
  finally { flushing = false; }
};
const push = (e) => { queue.push({ ...e, at: new Date().toISOString(), path: window.location.pathname + window.location.search }); if (queue.length >= 25) flush(); };

export const JourneyTracker = () => {
  const loc = useLocation();
  const last = useRef(null);
  useEffect(() => {
    const path = loc.pathname + loc.search;
    if (last.current === path) return;
    last.current = path;
    push({ kind: "page", label: document.title || "" });
  }, [loc]);
  useEffect(() => {
    const onClick = (ev) => {
      const el = ev.target?.closest?.("[data-testid], button, a, [role=button], input[type=submit]");
      if (!el) return;
      const label = el.getAttribute("data-testid") || el.getAttribute("aria-label") || el.tagName.toLowerCase();
      const text = (el.innerText || el.value || el.getAttribute("title") || "").trim().replace(/\s+/g, " ").slice(0, 80);
      if (label.startsWith("activity-") || label.startsWith("journey-")) return;
      push({ kind: "click", label, text });
    };
    const onHide = () => { if (document.visibilityState === "hidden") flush(); };
    document.addEventListener("click", onClick, true);
    document.addEventListener("visibilitychange", onHide);
    const t = setInterval(flush, 8000);
    return () => { document.removeEventListener("click", onClick, true); document.removeEventListener("visibilitychange", onHide); clearInterval(t); flush(); };
  }, []);
  return null;
};
